import { render, staticRenderFns } from "./NoAlcoholOrTobaccoDelivery.vue?vue&type=template&id=775ff4d8"
import script from "./NoAlcoholOrTobaccoDelivery.vue?vue&type=script&lang=js"
export * from "./NoAlcoholOrTobaccoDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports